var _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBondSingleOrDouble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: 3,
    strokeDashoffset: -3,
    fill: "#000000",
    stroke: "#000000",
    transform: "rotate(-45)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: "20%",
    y1: "30%",
    x2: "80%",
    y2: "30%"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: "20%",
    y1: "50%",
    x2: "80%",
    y2: "50%",
    strokeDashoffset: 0
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: "20%",
    y1: "70%",
    x2: "80%",
    y2: "70%"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBondSingleOrDouble);
export default __webpack_public_path__ + "static/media/bond_single_or_double.6331a4c08c60e6283e149fb6482fa136.svg";
export { ForwardRef as ReactComponent };